import { FC, useContext } from 'react';
import { styled } from '../../../../../packages/theme/stitches.config';
import { GenericSize } from '../../../../../packages/constants/generic';
import EventIcons, { EventIconsWrapper } from './EventIcons';
import { getIconAsBgImage } from '@sportal365/smp-widget-utils';
import { IMatchEvent } from '../../../../../packages/types';
import { ConfigContext } from '@velinsi/smp-widgets-ui';

interface ThumbProps {
  imageUrl?: string | null;
  borderColor: string;
  size?: GenericSize;
  events?: IMatchEvent[];
  context?: 'field' | 'default';
}

export const Thumb = styled('div', {
  position: 'relative',
  borderRadius: '4px 4px 0 0',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',

  [`& > ${EventIconsWrapper}`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },

  variants: {
    size: {
      large: {
        width: '39px',
        height: '39px',
      },
      small: {
        width: '34px',
        height: '34px',
      },
    },
  },

  defaultVariants: {
    size: 'small',
  },
});

const Border = styled('div', {
  width: '100%',
  variants: {
    size: {
      large: {
        height: '3px',
      },
      small: {
        height: '2px',
      },
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

export const ThumbComponent: FC<ThumbProps> = ({ imageUrl, borderColor, size = GenericSize.SMALL, events, context = 'default' }) => {
  const sizeValue = size === GenericSize.LARGE ? 'large' : 'small';
  const { dataTheme } = useContext(ConfigContext);

  const getPlaceholderIcon = () => {
    if (context === 'field') {
      return 'participant-placeholder-field';
    }

    return dataTheme === 'dark' ? 'participant-placeholder-dark' : 'participant-placeholder';
  };

  const placeholderIcon = getPlaceholderIcon();

  return (
    <div>
      <Thumb
        style={{
          backgroundImage: `url("${imageUrl || getIconAsBgImage(placeholderIcon)}")`,
        }}
        size={sizeValue}
      >
        {events && events.length > 0 && <EventIcons events={events} layout='corners' />}
      </Thumb>
      <Border css={{ backgroundColor: borderColor }} size={sizeValue} />
    </div>
  );
};
